var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-layout",attrs:{"id":"dashboard-layout"}},[_c('Menu',{attrs:{"editMode":_vm.editMode}}),_c('div',{staticClass:"main-content",class:{ 'stretch': _vm.stretchContent }},[_c('router-view')],1),_c('ConfirmDeleteQr'),_c('ConfirmDeleteCategory'),_c('DownloadQr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }